import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";

const KitchenTicketPage = () => {
  const { orderNumber } = useParams();
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTicket();
  }, [orderNumber]);

  const fetchTicket = async () => {
    try {
      const response = await axios.get(`${API}/orders/${orderNumber}/kitchen-ticket`);
      setTicket(response.data);
      
      // Auto-print after loading
      setTimeout(() => {
        window.print();
      }, 500);
    } catch (error) {
      console.error("Error fetching ticket:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p>Laster...</p>
      </div>
    );
  }

  if (!ticket) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p>Bestilling ikke funnet</p>
      </div>
    );
  }

  return (
    <div className="kitchen-ticket">
      <style>{`
        @media print {
          body { margin: 0; padding: 0; }
          .kitchen-ticket { 
            width: 80mm; 
            font-family: 'Courier New', monospace;
            font-size: 12px;
            line-height: 1.3;
          }
          .no-print { display: none !important; }
        }
        @media screen {
          .kitchen-ticket {
            width: 320px;
            margin: 20px auto;
            padding: 20px;
            font-family: 'Courier New', monospace;
            font-size: 14px;
            background: white;
            border: 2px dashed #ccc;
          }
        }
      `}</style>
      
      <pre style={{ whiteSpace: 'pre-wrap', margin: 0 }}>
        {ticket.ticket_text}
      </pre>
      
      <div className="no-print" style={{ marginTop: 20, textAlign: 'center' }}>
        <button 
          onClick={() => window.print()}
          style={{
            background: '#721111',
            color: 'white',
            padding: '10px 30px',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          🖨️ Skriv Ut
        </button>
      </div>
    </div>
  );
};

export default KitchenTicketPage;
